import apiService from './api';

export interface GstDetails {
  gstin: string;
  legalName: string;
  tradeName: string;
  name: string;        // trade name, falling back to legal name
  address: string;
  status: string;
  taxpayerType: string;
  registrationDate: string;
}

// GSTIN format: 2-digit state + 10-char PAN + entity code + 'Z' + checksum (matches the backend regex).
const GSTIN_RE = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
export const isValidGstin = (g: string): boolean => GSTIN_RE.test(String(g || '').trim().toUpperCase());

// Look up taxpayer details for a GSTIN via the backend proxy (keeps the API key server-side).
// Throws with a human-readable message on failure (invalid GSTIN, not configured, not found…).
export const lookupGst = async (gstin: string): Promise<GstDetails> => {
  const res: any = await apiService.get(`/gst/${encodeURIComponent(gstin.trim().toUpperCase())}`);
  return res.details as GstDetails;
};
